import { OrganizationCountry } from "../enums/country";
// Adding a new country forces an explicit choice here, so opening a country never silently exposes Tap to Pay.
export const TAP_TO_PAY_SUPPORTED_BY_COUNTRY = {
    [OrganizationCountry.Canada]: true,
    [OrganizationCountry.UnitedStates]: true,
    [OrganizationCountry.GreatBritain]: true,
    [OrganizationCountry.Australia]: true,
    [OrganizationCountry.NewZealand]: false,
    [OrganizationCountry.Ireland]: true,
    [OrganizationCountry.Germany]: true,
};
export const isTapToPaySupportedByCountry = (country) => {
    if (!country) {
        return false;
    }
    return TAP_TO_PAY_SUPPORTED_BY_COUNTRY[country] ?? false;
};
export const STRIPE_INTERAC_PRESENT_PAYMENT_METHOD_TYPE = "interac_present";
export const canTapToPayBeInterac = (country) => {
    return country === OrganizationCountry.Canada;
};
const STRIPE_TERMINAL_LOCATION_ID_BY_COUNTRY = {
    staging: {
        [OrganizationCountry.Canada]: "tml_Fxs8igZnLDhXaN",
        [OrganizationCountry.UnitedStates]: "tml_E9RGbwv9O59ZCk",
        [OrganizationCountry.GreatBritain]: "tml_GXbMXwOkMFPwak",
        [OrganizationCountry.Australia]: "tml_Ge7SQwDA25GqjD",
        [OrganizationCountry.Ireland]: "tml_GrLkTABmXTMKBy",
        [OrganizationCountry.Germany]: "tml_GrLkTABmXTMKBy",
    },
    production: {
        [OrganizationCountry.Canada]: "tml_Fxs8TATUxgnsvS",
        [OrganizationCountry.UnitedStates]: "tml_E9RIcQ2wgLwcFw",
        [OrganizationCountry.GreatBritain]: "tml_GXbMHQHodddVj7",
        [OrganizationCountry.Australia]: "tml_Ge7RwI8CQMF3RK",
        [OrganizationCountry.Ireland]: "tml_GrLjAQXQx8q2wb",
        [OrganizationCountry.Germany]: "tml_GrLjAQXQx8q2wb",
    },
};
export const getStripeTerminalLocationId = (country, environment) => {
    const environmentKey = environment === "production" ? "production" : "staging";
    return STRIPE_TERMINAL_LOCATION_ID_BY_COUNTRY[environmentKey][country] ?? null;
};
